module.exports = __webpack_public_path__ + "static/img/navier-logomark-simple.b9d50c5e.png";